import useDashboardStore from "views/hooks/useDashboardStore";
import useCoreStore from "views/hooks/useCoreStore";
import useDashboardApi from "../hooks/useDashboardApi";
import PendingPayments from "./PendingPayments";
import AnnualReceipts from "./AnnualReceipts";
import PendingRevenue from "./PendingRevenue";
import { useParams } from "react-router-dom";
import RevenueCard from "./RevenueCard";
import { useEffect } from "react";
import { Col, Row } from "antd";

export default function CardsStats() {
  const urlParams: RouteParams = useParams();
  const { listTotals, totalStatsData: data, loadingListTotals: loading } = useDashboardApi();

  const budgetNotInvoicedValue = useDashboardStore(state => state.budgetNotInvoicedValue);
  const paymentWaitingValue = useDashboardStore(state => state.paymentWaitingValue);
  const currency = useCoreStore(state => state.currency);
  const companySettingsLoading = useCoreStore(state => state.companySettingsLoading);

  const currencyCode = currency?.code;
  const decimalPlaces = currency?.decimalPlaces;

  useEffect(() => {
    if (urlParams?.companyId) {
      listTotals({
        variables: {
          companyId: urlParams?.companyId,
        },
      });
    }
  }, [urlParams?.companyId]);

  return (
    <div className="site-card-wrapper">
      <Row gutter={[24, 24]}>
        <Col md={6} sm={12} xs={24}>
          <RevenueCard
            loading={loading || companySettingsLoading}
            decimalPlaces={decimalPlaces ?? 0}
            currencyCode={currencyCode}
            percentage={data?.totalSaleDocument?.percentage}
            totalReturns={data?.totalSaleDocument?.totalReturns}
            totalValueN1={data?.totalSaleDocument?.totalValueN1}
            totalValue={data?.totalSaleDocument?.totalValueDefaultCurrency}
            totalSaleDocuments={data?.totalSaleDocument?.totalSaleDocuments}
          />
        </Col>
        <Col md={6} sm={12} xs={24}>
          <AnnualReceipts
            loading={loading || companySettingsLoading}
            decimalPlaces={decimalPlaces ?? 0}
            currencyCode={currencyCode}
            percentage={data?.totalPayments?.percentage}
            totalValueN1={data?.totalPayments?.totalValueN1}
            totalPayments={data?.totalPayments?.totalDocuments}
            totalValue={data?.totalPayments?.totalValueDefaultCurrency}
          />
        </Col>
        <Col md={6} sm={12} xs={24}>
          <PendingRevenue
            loading={loading || companySettingsLoading}
            decimalPlaces={decimalPlaces ?? 0}
            currencyCode={currencyCode}
            subtotal={budgetNotInvoicedValue}
            totalDocuments={data?.totalBudgetNotSaleDocument?.totalDocuments}
            totalValue={data?.totalBudgetNotSaleDocument?.totalValueDefaultCurrency}
          />
        </Col>
        <Col md={6} sm={12} xs={24}>
          <PendingPayments
            loading={loading || companySettingsLoading}
            decimalPlaces={decimalPlaces ?? 0}
            subtotal={paymentWaitingValue}
            currencyCode={currencyCode}
            totalReturns={data?.totalPaymentWaiting?.totalReturns}
            totalSaleDocuments={data?.totalPaymentWaiting?.totalSaleDocuments}
            totalValue={data?.totalPaymentWaiting?.totalValueDefaultCurrency}
          />
        </Col>
      </Row>
    </div>
  );
}
